export default __webpack_public_path__ + "static/media/ccb-mc.b9437644.png";